import smart_vehicle from "../../assets/smart_vehicle.jpeg";
import oee from "../../assets/oee_.png";
import {
  GitHub,
  LinkedIn,
  Twitter,
  Article,
  Code,
  RssFeed,
  Portrait,
} from "@mui/icons-material";

const data = [
  // {
  //   id: 1,
  //   title: "LinkedIn",
  //   link: "https://www.linkedin.com/in/sharooque7",
  //   icon: LinkedIn,
  // },
  {
    id: 2,
    title: "GitHub",
    src: "oee",
    link: "https://github.com/sharooque7",
    icon: GitHub,
  },
  {
    id: 3,
    title: "Hashnode Blogs",
    link: "https://sharooque.hashnode.dev/",
    icon: Article,
  },
  {
    id: 4,
    title: "Leetccode",
    link: "https://leetcode.com/u/sharooque7/",
    icon: Code,
  },
  {
    id: 5,
    title: "StackOverflow",
    src: "oee",
    link: "https://stackoverflow.com/users/10872378/sharooque",
    icon: RssFeed,
  },
  {
    id: 6,
    title: "Resume",
    src: "oee",
    link: "https://drive.google.com/file/d/1IiM0WDbiksJ6wAqW69JvMul2RGtGbf1L/view?usp=drive_link",
    icon: Portrait,
  },
];

export default data;
